import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import  { Redirect } from 'react-router-dom';
import NavMeauBar from '.././pageManager/const_childer/nav_meau';
import callApi from './../../utils/apicaler';
import '.././puclic/scss/style.css';   


class ThongTinKH extends React.Component{
    constructor(props){
            super(props);

            this.state = {
                loader:"",
                heyConten:"",
                showMeau:"",
                active:true,
                kh:[],
                isTrueLogin:false
            }
        }

        componentDidMount(){
            callApi('showkh', 'GET', null).then(res =>{
                this.setState({
                    kh : res.data
                })
            })

        const cookie = document.cookie
         if(cookie === "0fe8cf3262d72131ec5d304cd3d8190b"){
            this.setState({isTrueLogin : true})
         }


    }


    showMeau = () =>{
        this.setState({
            showMeau:"showMeau",
            heyConten:"heyConten"
        })
    }
    closeMeau = () =>{
        this.setState({
            showMeau:"",
            heyConten:""
        }) 
    }
  
    showgo=(datas)=>{
        var result = null;
            result = JSON.parse(datas).map((kh, index)=>{
                return ( 
                    <div>
                        <img src={`https://planet-time-linseed.glitch.me/${kh.setImageMain}`} width="50px" height="50px"/>                    
                        <p>Số lượng : {kh.qty}</p>
                        <p>Giá: {kh.price}</p>
                    </div>
                    
                )
            })
        return result;
    }
    showKh=(datas)=>{
        var result = null;
            result = datas.map((kh, index)=>{
                return ( 
                    <div>
                        <b>Mã đơn hàng: #{kh._id}</b>
                        <p>Tên khách hàng: {kh.lastname + kh.name}</p>
                        <p>Địa chỉ: {kh.diachi}</p>
                        <p>Sdt: {kh.sdt}</p>
                        {this.showgo(kh.product)}
                        <hr/>
                    </div>
                )
            })
        return result;
    }


    render(){
        const   {
                   kh ,loader, heyConten, showMeau
                } = this.state

        return(
            <div>
                
                <div className={`container-fluid custom-fluid ${loader}`}>
                    <div className="row custom_row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                            <div className="wapper" >
                                <div className={`nav_bar ${showMeau}`}>
                                    <h3>elsoule</h3>
                                    <hr/>
                                    <div className="nav_meau">
                                            <NavMeauBar activeThongTinkh={this.state.active} />
                                    </div>
                                </div>
                                <div className={`conten ${heyConten}`}>
                                        { heyConten === "heyConten" ? <div className="meau_mobi" onClick={this.closeMeau}> <CloseIcon /> </div> : <div className="meau_mobi" onClick={this.showMeau}> <MenuIcon /> </div> }
                                    <h3>Quản Lý Đơn Hànng </h3>
                                    <div>{this.showKh(kh)}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>              
                        
            )
    }
        

    }

export default ThongTinKH;